import moment from 'moment-timezone';
import { DeviceDataOverrideService } from '../../services';

const findMinDatapointFromAlert = (alert) => {
    if (alert.triggerThreshold.evaluationNumericValue != null) {
        if (alert.beforeThresholdExceededEventDataPoints && alert.afterThresholdExceededEventDataPoints && alert.beforeThresholdExceededEventDataPoints.length > 0 && alert.afterThresholdExceededEventDataPoints.length > 0) {
            const minBefore = alert.beforeThresholdExceededEventDataPoints.reduce(function(prev, current) {
                return (prev.numericValue < current.numericValue) ? prev : current
            });
            const minAfter = alert.afterThresholdExceededEventDataPoints.length > 0 ? alert.afterThresholdExceededEventDataPoints.reduce(function(prev, current) {
                return (prev.numericValue < current.numericValue) ? prev : current
            }) : minBefore;
            if (minBefore.numericValue >= minAfter.numericValue) {
                return minBefore;
            } else {
                return minAfter;
            }
        }
    }
    return null;
};

const findMaxDatapointFromAlert = (alert) => {
    if (alert.triggerThreshold.evaluationNumericValue != null) {
        if (alert.beforeThresholdExceededEventDataPoints && alert.afterThresholdExceededEventDataPoints && alert.beforeThresholdExceededEventDataPoints.length > 0 && alert.afterThresholdExceededEventDataPoints.length > 0) {
            const maxBefore = alert.beforeThresholdExceededEventDataPoints.reduce(function(prev, current) {
                return (prev.numericValue > current.numericValue) ? prev : current
            });
            const maxAfter = alert.afterThresholdExceededEventDataPoints.length > 0 ? alert.afterThresholdExceededEventDataPoints.reduce(function(prev, current) {
                return (prev.numericValue > current.numericValue) ? prev : current
            }) : maxBefore;
            if (maxBefore.numericValue <= maxAfter.numericValue) {
                return maxBefore;
            } else {
                return maxAfter;
            }
        }
    }

    return null;
};

const findEndTime = (thresholdExceededEvents) => {
    for (var i=0; i<thresholdExceededEvents.length-1; i++) {
        if (thresholdExceededEvents[i].triggerData != null) {
            return thresholdExceededEvents[i].triggerData.deviceTime;
        }
    }
    return null;
}

const findStartTime = (thresholdExceededEvents) => {
    for (var i=thresholdExceededEvents.length-1; i>0; i--) {
        if (thresholdExceededEvents[i].triggerData != null) {
            return thresholdExceededEvents[i].triggerData.deviceTime;
        }
    }
    return null;
}

const convertThresholdExceededEventsToDeviceReceivedData = (alert, timezone) => {
    const deviceTypeToken = alert?.thresholdExceededEvents?.length > 0 ? (alert?.thresholdExceededEvents[0]?.triggerData?.deviceDataType?.token) : ""; 
    const fnToApply = DeviceDataOverrideService.getOverrideFunctionForDeviceTypeToken(deviceTypeToken);

    let deviceReceivedDataValues = alert.beforeThresholdExceededEventDataPoints.map(reading => {
      const utcOffset = timezone ? moment(reading.deviceTime).tz(timezone).utcOffset() : moment(reading.deviceTime).utcOffset();
      return {
          amount: fnToApply(reading.numericValue),
          state: convertStateValue(reading),
          timestamp: Math.round(reading.deviceTime / 1000) + utcOffset * 60,
          provisional: false,
      };
    });

    var lastRealReadingValue = null;
    alert.thresholdExceededEvents
        .sort((entryA, entryB) => entryA.occurredAt - entryB.occurredAt)
        .forEach(thresholdExceededEvent => {
          if (thresholdExceededEvent.provisional === true) {
            if (lastRealReadingValue != null) {
              const utcOffset = timezone ? moment(thresholdExceededEvent.occurredAt).tz(timezone).utcOffset() : moment(thresholdExceededEvent.occurredAt).utcOffset();
              deviceReceivedDataValues.push({
                provisionalAmount: fnToApply(lastRealReadingValue.numericValue),
                provisionalState: convertStateValue(lastRealReadingValue),
                timestamp: Math.round(thresholdExceededEvent.occurredAt / 1000) + (utcOffset * 60),
                provisional: true
              });
            } else {
              const utcOffset = timezone ? moment(thresholdExceededEvent.occurredAt).tz(timezone).utcOffset() : moment(thresholdExceededEvent.occurredAt).utcOffset();
              deviceReceivedDataValues.push({
                provisionalAmount: 0,
                provisionalState: null,
                timestamp: Math.round(thresholdExceededEvent.occurredAt / 1000) + (utcOffset * 60),
                provisional: true
              });
            }
          } else {
            if (thresholdExceededEvent.triggerData) {
                const reading = thresholdExceededEvent.triggerData;
                lastRealReadingValue = reading;
                const utcOffset = timezone ? moment(reading.deviceTime).tz(timezone).utcOffset() : moment(reading.deviceTime).utcOffset();
                deviceReceivedDataValues.push({
                amount: fnToApply(reading.numericValue),
                state: convertStateValue(reading),
                timestamp: Math.round(reading.deviceTime / 1000) + (utcOffset * 60),
                provisional: false
                });
            }
          }
        });

    alert.afterThresholdExceededEventDataPoints.forEach(reading => {
      const utcOffset = timezone ? moment(reading.deviceTime).tz(timezone).utcOffset() : moment(reading.deviceTime).utcOffset();
      deviceReceivedDataValues.push({
          amount: fnToApply(reading.numericValue),
          state: convertStateValue(reading),
          timestamp: Math.round(reading.deviceTime / 1000) + (utcOffset * 60),
          provisional: false
        });
    });

    return deviceReceivedDataValues.sort((entryA, entryB) => entryA.timestamp - entryB.timestamp);
};

const convertStateValue = (reading) => {
    if (reading.stringValue) {
        return reading.stringValue;
    } else if (reading.booleanValue === true || reading.booleanValue === false) {
        return "" + reading.booleanValue;
    } else {
        return null;
    }
}

export { findMinDatapointFromAlert, findMaxDatapointFromAlert, findEndTime, findStartTime, convertThresholdExceededEventsToDeviceReceivedData };